<template>
  <PageWrapper
    :isLoading="isLoading"
    hasFilters
    @submitFilters="setPageNumberAndSendRequest"
  >
    <template #title>
      جزئیات مشاور
      <span v-if="supportList && supportList.length">
        {{supportList[0].counselName}}
      </span>
    </template>
    <template #filters>
      <SearchInput
        class="filters-width w-24"
        inputId="studentFullName"
        inputLabel="جستجو بر اساس نام زبان آموز"
        inputPlaceholder="علی..."
        v-model="supportListFilters.studentFullName"
        @enter="setPageNumberAndSendRequest"
      ></SearchInput>

<!--      <SearchInput
        class="filters-width w-24"
        inputId="masterFullName"
        inputLabel="جستجو بر اساس نام استاد"
        inputPlaceholder="محمد..."
        v-model="supportListFilters.masterFullName"
        @enter="setPageNumberAndSendRequest"
      ></SearchInput>-->

      <RangeDatePicker
        class="w-24 filters-width"
        label="بازه‌ی تاریخ پشتیبانی را انتخاب کنید"
        :defaultDateRange="defaultDateRange"
        @getDateRange="setDateRange"
      ></RangeDatePicker>
    </template>

    <CustomTable
      :pageNumber="supportListFilters.pageNumber"
      :count="supportListFilters.count"
      :totalCount="totalCount"
      :tableColumns="tableColumns"
      :tableItems="supportList"
      @changePage="changePage"
    >
      <template #index="data">
        {{
          Math.ceil(
            data.index +
              1 +
              (supportListFilters.pageNumber - 1) * supportListFilters.count
          )
        }}
      </template>
    </CustomTable>
  </PageWrapper>
</template>

<script>
export default {
  mounted() {
    this.setDatesFromQuery();

    if (this.computedPageRouteQuery) {
      this.supportListFilters.pageNumber = this.computedPageRouteQuery;
    }
    this.getAllSupportList();
  },

  data() {
    return {
      isLoading: false,

      supportList: null,
      totalCount: null,
      defaultDateRange: [],

      supportListFilters: { //date update with query
        pageNumber: 1,
        count: 10,
        counselId: this.$route.params.id,
        startDateTime:  null,
        endDateTime:  null,
        studentFullName: this.$route.query.studentFullName || null,
        masterFullName: this.$route.query.masterFullName || null,
      },

      tableColumns: [
        {
          key: "index",
          label: "ردیف",
        },
        {
          key: "customerName",
          label: "نام کاربر",
        },
        {
          key: "basePrice",
          label: "قیمت پایه",
          formatter: (value) =>
            value ? `${Intl.NumberFormat("en-US").format(value)} تومان` : "-",
        },
        {
          key: "counselPercentage",
          label: "درصد سود استاد",
          formatter: (value) => (value ? `${value}%` : "-"),
        },
        {
          key: "time",
          label: "زمان مشاوره",
          formatter: (value) => `${value || 0} دقیقه`,
        },
        {
          key: "startDateTime",
          label: "تاریخ شروع",
          formatter: (value) =>
            value
              ? `${new Date(value).toLocaleDateString("fa-IR")} - ${new Date(
                  value
                ).toLocaleTimeString("fa-IR", {
                  minute: "2-digit",
                  hour: "2-digit",
                })}`
              : "-",
        },
        {
          key: "endDateTime",
          label: "تاریخ پایان",
          formatter: (value) =>
            value
              ? `${new Date(value).toLocaleDateString("fa-IR")} - ${new Date(
                  value
                ).toLocaleTimeString("fa-IR", {
                  minute: "2-digit",
                  hour: "2-digit",
                })}`
              : "-",
        },
      ],
    };
  },

  methods: {
    setPageNumberAndSendRequest() {
      this.supportListFilters.pageNumber = 1;
      this.setPageNumberQuery(1);
      this.getAllSupportList();
    },

    changePage(pageNumber) {
      this.supportListFilters.pageNumber = pageNumber;
      this.setPageNumberQuery(pageNumber);
      this.getAllSupportList();
    },

    setPageNumberQuery(pageNumber) {
      this.$router.replace({
        path: this.$route.path,
        query: {
          page: pageNumber,
        },
      });
    },

    async getAllSupportList() {
      try {
        this.isLoading = true;

        const _this = this;

        const getAllConsultList = new GetAllConsultList(_this);
        getAllConsultList.setRequestParamDataObj(_this.supportListFilters);

        await getAllConsultList.fetch((res) => {
          if (res.isSuccess) {
            _this.supportList = res.data.data;
            _this.totalCount = res.data.count;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    setDateRange(dateRange) {
      if (dateRange && dateRange.length > 0) {
        this.supportListFilters.startDateTime = new Date(
          dateRange[0]
        ).toISOString();
        this.supportListFilters.endDateTime = new Date(
          dateRange[1]
        ).toISOString();
      } else {
        this.supportListFilters.startDateTime = null;
        this.supportListFilters.endDateTime = null;
      }
    },
    setDatesFromQuery() {
      const queries = this.$route.query;
      if (queries.startDateTime && queries.endDateTime) {
        this.supportListFilters.startDateTime = new Date(+queries.startDateTime).toISOString();
        this.supportListFilters.endDateTime = new Date(+queries.endDateTime).toISOString();

        this.defaultDateRange = [
          this.splitByDatePart(new Date(+queries.startDateTime).toISOString()),
          this.splitByDatePart(new Date(+queries.endDateTime).toISOString()),
        ];
      }
    },
    splitByDatePart(isoDate) {
      return isoDate.split("T")[0];
    },
  },

  computed: {
    computedPageRouteQuery() {
      if (this.$route.query && this.$route.query.page) {
        return this.$route.query.page;
      }
      return null;
    },
  },

  components: {
    PageWrapper,
    CustomTable,
    SearchInput,
    RangeDatePicker,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import RangeDatePicker from "@/views/components/Utils/RangeDatePicker.vue";

import { GetAllConsultList } from "@/libs/Api/Counseling";
</script>
